const TransactionService = {
    compareTransactions : (a, b) => {
        const dateDiff = new Date(b.date).getTime() - new Date(a.date).getTime();
        if (dateDiff !== 0) {
            return dateDiff;
        }
        const aId = a?.id;
        const bId = b?.id;
        const aNum = typeof aId === 'number' ? aId : Number(aId);
        const bNum = typeof bId === 'number' ? bId : Number(bId);
        if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) {
            return bNum - aNum;
        }
        return String(bId ?? '').localeCompare(String(aId ?? ''));
    },
    transactionDaysToMap : (transactionDays) => {
        const map = new Map();
        transactionDays.forEach(day => {
            map.set(day.date, { ...day }); // Clone existing days
        });
        return map;
    },
    mapToTransactionDays : (map) => {
        return Array.from(map.values())
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    add : (transactions, transaction) => {
        const newTransactions = [...transactions, transaction];
        newTransactions.sort(TransactionService.compareTransactions);
        return newTransactions;
    }
}

export default TransactionService